export default "__VITE_ASSET__C163Lk8X__"